import { getThemeForKey, HorizontalAlignment } from "@mcleod/core";
import { ClickEvent } from "../../events/ClickEvent";
import { PanelProps } from "../panel/PanelProps";
import { Tab } from "./Tab";
import { TabSelectorPanel } from "./TabSelectorPanel";

export class TabSelectorPanelOutlined extends TabSelectorPanel {
    private static readonly themeObjectSelected = getThemeForKey("tabset.headingOutlinedSelected") ?? {};
    private static readonly themeObjectUnselected = getThemeForKey("tabset.headingOutlinedUnselected") ?? {};

    constructor(tab: Tab, props?: Partial<PanelProps>) {
        const isVerticalTabset = tab.isVertical();
        const tabAlignmentIsBottom = tab.tabAlignmentIsBottom();
        const tabAlignmentIsLeft = tab.tabAlignmentIsLeft();
        const tabAlignmentIsRight = tab.tabAlignmentIsRight();
        const tabAlignmentIsTop = tab.tabAlignmentIsTop();
        super(tab, {
            // Border radius values
            borderBottomLeftRadius: tabAlignmentIsBottom || tabAlignmentIsLeft ? 4 : null,
            borderBottomRightRadius: tabAlignmentIsBottom || tabAlignmentIsRight ? 4 : null,
            borderTopLeftRadius: tabAlignmentIsTop || tabAlignmentIsLeft ? 4 : null,
            borderTopRightRadius: tabAlignmentIsTop || tabAlignmentIsRight ? 4 : null,
            // Border width values
            borderBottomWidth: tabAlignmentIsTop ? 0 : 1,
            borderLeftWidth: tabAlignmentIsRight ? 0 : 1,
            borderRightWidth: tabAlignmentIsLeft ? 0 : 1,
            borderTopWidth: tabAlignmentIsBottom ? 0 : 1,
            // Other property values
            align: isVerticalTabset ? HorizontalAlignment.LEFT: HorizontalAlignment.CENTER,
            fillRow: false,
            marginRight: tabAlignmentIsTop ? 6 : 0,
            paddingBottom: isVerticalTabset ? 8 : 4,
            paddingLeft: isVerticalTabset ? 16 : 18,
            paddingRight: isVerticalTabset ? 12 : 18,
            paddingTop: isVerticalTabset ? 8 : 4,
            rowBreak: isVerticalTabset,
            themeKey: "tabset.headingOutlinedUnselected",
            ...props
        });
        this.addClickListener((event: ClickEvent) => {
            this.tab.select(event);
            this.tab.selectInDesigner();
        });
    }

    protected override get selectedThemeObject(): any {
        return TabSelectorPanelOutlined.themeObjectSelected;
    }

    protected override get unselectedThemeObject(): any {
        return TabSelectorPanelOutlined.themeObjectUnselected;
    }
}
